<script>
import gql from "graphql-tag";
import { tournamentMatchFragment } from "@/graphql/tournament";
import { DialogInputTypes } from "@/js/helper";
import BaseDialog from "./baseDialog.vue";

export default {
  name: "SimulatePlayDialog",
  extends: BaseDialog,
  props: { tournament: Object },
  data: function() {
    return {
      nMatches: {
        label: "Number of matches to simulate",
        type: DialogInputTypes.number,
        value: -1,
        hint: "To simulate all matches use -1"
      },
      probabilityOfUpsets: {
        label: "Probability of upset as a %",
        value: 0,
        hint: "A number between 0 and 1",
        type: DialogInputTypes.number
      }
    };
  },
  computed: {
    dialogInputs: {
      get() {
        return [this.nMatches, this.probabilityOfUpsets];
      }
    },
    title: {
      get() {
        return "Simulate play";
      }
    },
    instructions: {
      get() {
        return "Run a simulation that completes matches by choosing a winner based on the given probability of upsets.";
      }
    }
  },
  methods: {
    submit() {
      return this.$apollo
        .mutate({
          mutation: gql`
            mutation(
              $tournamentId: ID!
              $nMatches: Int
              $probabilityOfUpsets: Float
            ) {
              simulatePlay(
                tournamentId: $tournamentId
                nMatches: $nMatches
                probabilityOfUpsets: $probabilityOfUpsets
              ) {
                ...TournamentMatch
              }
            }
            ${tournamentMatchFragment}
          `,
          variables: {
            tournamentId: this.tournament.id,
            nMatches: this.nMatches.value,
            probabilityOfUpsets: this.probabilityOfUpsets.value
          }
        })
        .then(result => {
          this.$root.$emit("updateTournament", this.tournament.id);
          this.$store.commit("setNotification", `Simulation completed`);
        })
        .catch(err => {
          console.log(err);
          window.alert("Failed to simulate play");
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// simulatePlayDialog.vue?d0324e88